<template>
  <div class="header-banner">
    <img :src="bannerUrl" alt="Header Banner" />
  </div>
</template>

<script>
export default {
  name: "HeaderBanner",
  props: {
    bannerUrl: {
      type: String,
      default: "",
    },
  }
};
</script>

<style lang="less" scoped>
.header-banner {
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}
</style>
